<template>
  <a-modal
    :visible="visible"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    :title="isEdit ? '新增配置' : '编辑配置'"
    :width="600"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-form-item label="事业部">
          <a-select placeholder="--请选择事业部--" v-decorator="['bussdepId']" style="width:200px" :disabled="isEdit">
            <a-select-option :key="businss.id" v-for="businss in businssDept">{{ businss.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="业务">
          <a-select placeholder="--请选择业务--" v-decorator="['bussdepType']" style="width:200px" :disabled="isEdit">
            <a-select-option :key="~~bussdep.key" v-for="bussdep in bussdepType">{{ bussdep.value }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="应用名称">
          <a-input
            placeholder="请输入应用名称"
            v-decorator="['name', { rules: [{ required: true, message: '请输入应用名称' }] }]"
            style="width:200px"
          ></a-input>
        </a-form-item>
        <a-form-item label="回调URL">
          <a-input
            placeholder="请输入回调URL"
            v-decorator="['callbackurl', { rules: [{ required: true, message: '请输入回调URL' }] }]"
            style="width:200px"
          ></a-input>
        </a-form-item>
        <a-form-item label="状态" v-show="isEdit">
          <a-radio-group v-decorator="['status', { initialValue: 1 }]" style="width:200px">
            <a-radio :value="1">正常</a-radio>
            <a-radio :value="2">暂停</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import modalMixin from '@/components/mixins/modal'
import { bussdepType } from '@/config/public'
import { mapGetters } from 'vuex'
import { blacklistconfAdd, blacklistconfEdit } from '@/api/blackListSync'
import { depList } from '@/api/common'
export default {
  mixins: [modalMixin],
  data() {
    return {
      isEdit: false,
      bussdepType: [],
      businssDept: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'modifyModal' })
    this.form.getFieldDecorator('id', { preserve: true })
  },
  mounted() {
    this.bussdepType = bussdepType
    this.getBussdep()
  },
  methods: {
    getBussdep() {
      depList().then(res => {
        if (res.code == 1) {
          this.businssDept = res.result
        }
      })
    },
    async handleOpen() {},
    handleClose() {},
    handleOk() {
      this.form.validateFields(async (errors, values) => {
        if (errors) return
        try {
          this.loading = true
          const api = this.isEdit ? blacklistconfEdit : blacklistconfAdd
          const { id } = values
          const params = values
          if (id) {
            params.blackListConfId = id
          }
          const { code, message } = await api(params)
          if (code === 1) {
            this.$emit('success')
            this.$message.success(message)
            this.handleCancel()
          } else {
            this.$message.error(message)
          }
        } catch (error) {
          console.error(error)
          this.$message.error(error.message)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped></style>
